import { render } from "./BannerWeaponDefault.vue?vue&type=template&id=3a19143e&scoped=true"
import script from "./BannerWeaponDefault.vue?vue&type=script&lang=js"
export * from "./BannerWeaponDefault.vue?vue&type=script&lang=js"

import "./BannerWeaponDefault.vue?vue&type=style&index=0&id=3a19143e&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a19143e"]])

export default __exports__